export default __webpack_public_path__ + "static/media/disable4.af78167e.png";